export const filterBoxConfig = {
  show: true,
  keyMap: { name: 'label', key: 'short_key', owner: 'username' },
  itemToStringKeys: ['label', 'short_key', 'id'],
  exampleModifiers: ['key', 'name', 'id']
};
